/**
 * AppsMarketplacePage — standalone /marketplace/apps route. The actual
 * tile + modal logic lives in AppsMarketplaceSection so the same code
 * runs whether the catalog is browsed on its own page (this route) OR
 * embedded under the Workflow Marketplace on /marketplace.
 *
 * Keep this wrapper trivial — only adds the page-level layout (h1 +
 * subtitle + max-width container). The section component owns its
 * heading when embedded; the wrapper overrides it with the bigger
 * page-level title here.
 */
import React from 'react';
import AppsMarketplaceSection from './AppsMarketplaceSection';
import '../MarketplacePage/MarketplacePage.css';

const AppsMarketplacePage = () => (
  <div className="marketplace-page marketplace-page--apps-only">
    <header className="marketplace-header">
      <div className="marketplace-title-row">
        <div className="marketplace-title-left">
          <h1 className="marketplace-title">App Marketplace</h1>
          <p className="marketplace-subtitle">
            One-click deploy of popular open-source apps. Each instance is
            private to you, managed by an AI ops agent that handles install,
            monitoring, and upgrades.
          </p>
        </div>
      </div>
    </header>
    {/* Standalone page already shows the h1; suppress the section's
        own h2 to avoid duplicate "App Marketplace" headings. */}
    <AppsMarketplaceSection showHeader={false} />
  </div>
);

export default AppsMarketplacePage;
